import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DistributionChannelEditor.html?raw';
import lang from 'dojo/_base/lang';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { ExpandableSection, ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import EvBookingView from '../../EvBookingEditor/EvBookingView';
import GenericEntityView from '../../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import { ToasterHelpers } from "../../../more/Helpers";

interface EvBookingEntry {
    ID: string;
    ref_ev_booking: {
        ID: string,
        Classname: string,
        $Displayname: string,
        ev_booking_name: string,
        date_start: Date,
        date_end: Date,
        ref_ev_activity_status: { description: string },
        ref_ev_booking_status: { description: string }
    }
    isDeleted?: boolean;
    isNew?: boolean;
}
class DistributionChannelEditor extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    private sectionEntityView_DistributionChannel_Special: HTMLElement;
    private EntityViewContainer_DistributionChannel_Special: HTMLElement;

    private input_ArtisticPeriod: MdsLax<InstanceType<typeof SearchSelect>>;
    private input_DistributionType: MdsLax<InstanceType<typeof SearchSelect>>;

    private expanderEvBookings: MdsLax<InstanceType<typeof ExpandableSection>>
    private bookingsTable: MdsLax<InstanceType<typeof StaticTable>> = null;
    private tableContainer: HTMLElement;

    private _updateTableTimeoutHandler: any = null;

    isValid(): boolean {
        let isValid = true;
        isValid = isValid && this.getAttributeValue("description");
        return isValid;
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.DistributionChannel;
    }

    private setDistributionType() {

        let vals = this.input_DistributionType.getAllValues();
        let def = vals.filter(v => { v["isDefaultValue"] === true })[0];
        if (def) this.input_DistributionType.setValue(def["value"]);
        else this.input_DistributionType.setValue(vals[0]["value"]);
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        this._setupEntityviewSpecialSection();

        if (!this.isNew) this.createContextButton({
            name: "copyDistributionChannel",
            label: this.translate("MainCatalogsEditor_Label_CopyDistributionChannel"),
            callback: lang.hitch(this, this.copyToOtherSeason),
            permanent: false,
            placement: "primarymenu",
            iconClass: "fas fa-clone",
        });
    }

    private _setupEntityviewSpecialSection() {

        this.hideNode(this.sectionEntityView_DistributionChannel_Special);
        this.UiModder.domConstruct.empty(this.EntityViewContainer_DistributionChannel_Special);

        if (!this.entityId) return;

        if (this.hasFeature("MainCatalog/DistributionChannelsSpecial")) {

            let entityview = new GenericEntityView();

            entityview.setup(this.entityId,
                this.entityClass,
                this.getDisplayname(),
                "",
                this.EntityViewContainer_DistributionChannel_Special,
                null,
                "distributionChannel_Special");

            entityview.hideIfEmpty(true, lang.hitch(this, this.hideNode, this.sectionEntityView_DistributionChannel_Special));
        }
    }
    private _setUpTable(response: { layouts: Array<any> }) {

        if (this.bookingsTable != null) this.bookingsTable.destroy();

        this.bookingsTable = new StaticTable();
        this.bookingsTable.placeAt(this.tableContainer);

        this.bookingsTable.setLayout(response.layouts[0]);

        this.bookingsTable.setRowClick(lang.hitch(this, this._onRowClick))

        this._updateTableTimeoutHandler = setTimeout(() => {
            this.updateDescriptionsTable();
        }, 500);
    }

    private updateDescriptionsTable() {
        this.StandbyStop("tableLoad");
        let bookings: Array<EvBookingEntry> = lang.clone(this.getAttributeValue("EL_ht_evbooking_evdistribution_ev_distribution_cha"));

        bookings?.length > 0 ? this.expanderEvBookings.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderEvBookings.setMarking(ExpandableSectionMarkings.default);

        this.bookingsTable.setData(bookings);

        bookings?.forEach(s => {
            if (s.isDeleted === true) {
                this.disableNode(this.bookingsTable.getRowGroupByKeyValue(s.ID, "ID").rows[0].node);
            }
        })
    }
    private _onRowClick(row: StaticTable.StaticTableRow<EvBookingEntry>) {

        var bookingView: MdsLax<InstanceType<typeof EvBookingView>> = new EvBookingView();

        var entity = row.rowGroup.entity;

        bookingView.setup(entity.ref_ev_booking.ID,
            entity.ref_ev_booking.$Displayname,
            null,
            this.getTabContainerName());
    }

    private copyToOtherSeason() {

        let dlg = new GenericDialog();
        let periodSelect = new SearchSelect();

        let existingValues: Array<{ entity: { ID: string, description: string } }> = this.input_ArtisticPeriod.getAllValues() as Array<any>;
        let selectedVal = this.input_ArtisticPeriod.getValue(false);
        let values: Array<string> = [];
        let labels: Array<string> = [];
        let selectable: Array<boolean> = [];

        existingValues.forEach(v => {
            values.push(v.entity.ID);
            labels.push(v.entity.description);
            selectable.push(selectedVal !== v.entity.ID);
        })

        periodSelect.setOptions(values, labels, null, selectable)

        dlg.enableContentOverflow(true);
        dlg.show(periodSelect, this.translate("MainCatalogsEditor_Label_SelectTargetPeriod"), null, null, "submitcancel", (res) => {

            if (res === 1) {
                let targetPeriodID = periodSelect.getValue();
                let sourceChannelID = this.entityId;

                this.RequestManager.callfunction(
                    "Webtool__MainCatalogsEditor_DistributionChannel_CloneForSeason",
                    {
                        targetPeriodID: targetPeriodID,
                        sourceChannelID: sourceChannelID
                    },
                    lang.hitch(this, this._onCopyToOtherSeasonResponse),
                    (err) => {
                        this.showToast(
                            {
                                title: err.Message,
                                iconClass: ToasterHelpers.ToasterIcons.error
                            })
                    }
                )
            } 
        }, { size: "smaller" })
    }
    private _onCopyToOtherSeasonResponse(entity: any) {
        this.showToast({
            title: this.translate("General_SavingSuccessful"),
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        });
        this.emit("RequestNewEditorInstance", entity);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.StandbyStart(this.expanderEvBookings.domNode, "tableLoad");
        this.RequestManager.callfunction(
            "Webtool__MainCatalogsEditor_GetBookingTableForDistributionChannel",
            null,
            lang.hitch(this, this._setUpTable),
            (err) => { this.showToast(err.Message) }
        )
        if (this.isNew) this.input_DistributionType.on("loaded", lang.hitch(this, this.setDistributionType));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(DistributionChannelEditor);